/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Answers from './Answers/index'
import CancelAction from './CancelAction/index'
import CommunicationPreferences from './CommunicationPreferences/index'
import GoToProfileAction from './GoToProfileAction/index'
import Heading from './Heading/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import MiscStats from './MiscStats/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import NextAction from './NextAction/index'
import PersonDetails from './PersonDetails/index'
import PreviousAction from './PreviousAction/index'
import React from 'react'
import ResponsiblePersonDetails from './ResponsiblePersonDetails/index'
import TysaiaProfileSectionNoDetails from 'DesignSystem/TysiaProfileElements/TysaiaProfileSectionNoDetails/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Detail/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let selectedLeadMetadataResponsibleFirstnameValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.metadata.responsible.firstName',
})
let selectedLeadMetadataResponsibleFirstnameValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.metadata.responsible.firstName',
})
let selectedLeadMetadataAnswersValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'lead.metadata.answers',
format: fromFormat.isEmptyList,
})
let selectedLeadMetadataAnswersValueData1 = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'lead.metadata.answers',
format: fromFormat.isEmptyList,
})
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let selectedLeadPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.patient_id',
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Heading
  viewPath={`${viewPath}/Heading`}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Person/Patient Details"
 level="h4"
/>
<PersonDetails
  viewPath={`${viewPath}/PersonDetails`}
/>
</div>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Responsible Person Details"
 level="h4"
/>
<fromFlow.When is={!selectedLeadMetadataResponsibleFirstnameValueData}>
<TysaiaProfileSectionNoDetails
  viewPath={`${viewPath}/TysaiaProfileSectionNoDetails`}
 data="selected.lead.metadata.responsible.firstName"
/>
</fromFlow.When>
<fromFlow.When is={selectedLeadMetadataResponsibleFirstnameValueData1}>
<ResponsiblePersonDetails
  viewPath={`${viewPath}/ResponsiblePersonDetails`}
 data="selected.lead.metadata.responsible.firstName"
/>
</fromFlow.When>
</div>
</div>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 width="95%"
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
/>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--mt-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical2}`}
>
<CommunicationPreferences
  viewPath={`${viewPath}/CommunicationPreferences`}
/>
</div>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
 width="95%"
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
/>
<div
  data-testid="Content.Vertical:4"
  data-view-path={viewPath}
 style={{'--mt-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Additional Questions"
 level="h4"
/>
<fromFlow.When is={selectedLeadMetadataAnswersValueData}>
<TysaiaProfileSectionNoDetails
  viewPath={`${viewPath}/TysaiaProfileSectionNoDetails`}
 data="selected.lead.metadata.answers"
 format="/Data/format.js isEmptyList"
/>
</fromFlow.When>
<fromFlow.When is={!selectedLeadMetadataAnswersValueData1}>
<Answers
  viewPath={`${viewPath}/Answers`}
 data="selected.lead.metadata.answers"
 format="/Data/format.js isEmptyList"
/>
</fromFlow.When>
</div>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
 width="95%"
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
/>
<div
  data-testid="Content.Vertical:5"
  data-view-path={viewPath}
 style={{'--mt-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical4}`}
>
<MiscStats
  viewPath={`${viewPath}/MiscStats`}
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-4-Z1Yf8zk': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<PreviousAction
  viewPath={`${viewPath}/PreviousAction`}
/>
<NextAction
  viewPath={`${viewPath}/NextAction`}
/>
</div>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<fromFlow.When is={selectedLeadPatientIdValueData}>
<GoToProfileAction
  viewPath={`${viewPath}/GoToProfileAction`}
 data="selected.lead.patient_id"
/>
</fromFlow.When>
</div>
</div>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}